import { render, staticRenderFns } from "./NotifyPanel.vue?vue&type=template&id=378b76e7&scoped=true"
import script from "./NotifyPanel.vue?vue&type=script&lang=ts"
export * from "./NotifyPanel.vue?vue&type=script&lang=ts"
import style0 from "./NotifyPanel.vue?vue&type=style&index=0&id=378b76e7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "378b76e7",
  null
  
)

export default component.exports